import React from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import _ from 'lodash';
import HighCharts from 'highcharts';
import { observer, inject } from 'mobx-react';
import numeral from 'numeral';

@observer
class ComparisonComparedProvidersOutputComponent extends React.Component {
  constructor(props) {
    super(props);

    this.addHighCharts = this.addHighCharts.bind(this);
    this.determinePointWidth = this.determinePointWidth.bind(this);
  }

  componentDidMount() {
    const { comparedProviderData } = this.props.ComparisonFormData;

    const comparedProviders = comparedProviderData.labels.map(provider => (
      {
        labelName: provider.labelId,
        logo: provider.logo,
        value: provider.totalInterestCosts,
        category: provider.labelId,
        hasAutoRiskClassReduction: provider.hasAutoRiskClassReduction,
      }
    ));
    this.props.ComparisonFormData.previousScreenWidth = '';
    const $initialWindowWidth = $(document).width();
    this.determinePointWidth($initialWindowWidth, comparedProviders);

    $(window).on('resize', () => {
      const $documentWidth = $(document).width();
      this.determinePointWidth($documentWidth, comparedProviders);
      this.props.ComparisonFormData.previousScreenWidth = $documentWidth;
    });
  }

  componentWillUnmount() {
    $(window).off('resize');
  }

  determinePointWidth($documentWidth, comparedProviders) {
    const { previousScreenWidth } = this.props.ComparisonFormData;

    if ($documentWidth < 1320 && $documentWidth > 770 &&
      (!previousScreenWidth || previousScreenWidth > 1320 ||
        previousScreenWidth < 770)) {
      this.addHighCharts(comparedProviders, 120);
    }

    if ($documentWidth < 770 && (!previousScreenWidth || previousScreenWidth > 770)) {
      this.addHighCharts(comparedProviders, 90);
    }

    if ($documentWidth > 1320 && (!previousScreenWidth || previousScreenWidth < 1320)) {
      this.addHighCharts(comparedProviders, 170);
    }
  }

  addHighCharts(comparedProviders, pointWidth) {
    HighCharts.chart('comparison-container__barchart', {
      chart: {
        type: 'column',
        height: 425,
      },
      title: {
        text: '',
      },
      xAxis: {
        categories: [comparedProviders[0].category, comparedProviders[1].category],
        tickLength: 0,
        lineWidth: 3,
        lineColor: '#5f687c',
        labels: {
          useHTML: true,
          formatter() {
            const logo = comparedProviders[this.pos].logo;

            return (`
                <img class="comparison-logo" src="${logo}"/>
            `);
          },
          rotation: 0,
        },
      },
      yAxis: {
        gridLineWidth: 0,
        minorGridLineWidth: 0,
        min: Math.round(_.max([comparedProviders[0].value, comparedProviders[1].value]) / 3),
        title: {
          text: '',
        },
        labels: {
          enabled: false,
        },
        stackLabels: {
          enabled: false,
          style: {
            fontWeight: 'bold',
            color: (HighCharts.theme && HighCharts.theme.textColor) || 'gray',
          },
        },
      },
      legend: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        enabled: false,
      },
      plotOptions: {
        column: {
          stacking: 'normal',
          dataLabels: {
            useHTML: true,
            enabled: true,
            verticalAlign: 'bottom',
            // style: { top: '105px', fontWeight: 'bold' },
            color: (HighCharts.theme && HighCharts.theme.dataLabelsColor) || 'white',
            formatter() {
              const self = this;
              const provider = comparedProviders.find(item => item.category === self.x);

              let showTermInterestRateIcon = '';

              if (provider.hasAutoRiskClassReduction) {
                showTermInterestRateIcon = `
                  <img
                    src="/images/looptijdrente-icoon-lichtblauw.svg"
                    alt="looptijdrente icoon lichtblauw">`;
              }

              return (
                `<div class="comparison-container__barchart__y-data-labels">
                  ${showTermInterestRateIcon}
                  <div class="comparison-container__barchart__interest">
                    ${numeral(provider.value).format('$ 0,00')}
                  </div>
                </div>`
              );
            },
          },
        },
      },
      series: [{
        name: comparedProviders[0].category,
        data: [comparedProviders[0].value, comparedProviders[1].value],
        pointWidth,
        color: '#1a3558',
      }],
    });
  }


  render() {
    return (
      <div id="comparison-container__barchart" />
    );
  }
}

ComparisonComparedProvidersOutputComponent.propTypes = {
  ComparisonFormData: PropTypes.shape({
    comparedProviderData: PropTypes.shape({}),
    previousScreenWidth: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  }),
};

ComparisonComparedProvidersOutputComponent.defaultProps = {
  ComparisonFormData: {},
};

export default inject('ComparisonFormData')(ComparisonComparedProvidersOutputComponent);
